<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells__title">
        <span>{{form.sp_name}}</span>
      </div>
      <div class="weui-cells">
        <category-field label v-model="form.sp_caid" @select="onSelectCategory" />
      </div>
      <div class="weui-cells__title">
        <span>{{help}}</span>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CategoryField from "@/components/field/CategoryField.vue";

export default {
  components: {
    CategoryField
  },
  data() {
    return {
      form: {
        sp_name: null,
        sp_caid: null
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.form = to.params.initData;
    });
  },
  computed: {
    /**
     * 辅助文字描述
     */
    help() {
      var code = this.form.sp_description;
      return {
        defaultReceivable: "用于生成销售单据、收款单、核销单、应收调账单凭证",
        defaultPayable: "用于生成采购单据、付款单、核销单、应付调账单凭证",
        defaultPreReceivable: "用于生成收款单、核销单-预收冲应收凭证",
        defaultPrePayable: "用于生成付款单、核销单-预付冲应付凭证",
        defaultLossRate: "用于生成期末汇兑损益凭证",
        defaultStock: "用于生成出入库单据、结转成本凭证",
        defaultIncome: "用于生成销售单据凭证",
        defaultCost: "用于生成采购单据凭证",
        defaultSellSubject: "用于生成销售单据凭证",
        defaultBuySubject: "用于生成采购单据凭证",
        defaultStockpro: "用于生成库存盘亏凭证",
        defaultStocklose: "用于生成库存盘盈凭证",
        materialDiffer: "用于生成采购单据凭证",
        makeCostMaterial: "用于生成制造出入库凭证",
        makeCostMan: "用于生成制造出入库凭证",
        makeCostMake: "用于生成制造出入库凭证",
        osMakeCost: "用于生成外协出入库凭证",
        makeCost: "用于生成结转制造费用凭证",
        defaultYearProfit: "用于生成期末结转损益凭证"
      }[code];
    }
  },
  methods: {
    onSelectCategory(selection) {
      var me = this,
        main = me.form;
      main.sp_cacode = selection.ca_code;
      main.sp_caname = selection.ca_name;
    },
    save() {
      var me = this;
      me.$loading({
        url: "/api/finance/scmparameter/update",
        method: "POST",
        jsonData: [me.form]
      })
        .then(function(res) {
          if (res.success) {
            me.$weui.toast("设置成功", 2000);
            me.$router.back();
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("设置失败", 3000);
        });
    }
  }
};
</script>